/** Session-only flag (tab scope); set from Help chat, read anywhere in the LYW app. */
export const SESSION_DEBUG_MODE_KEY = 'lyw_session_debug_mode';

/** Fired on `window` when debug mode is toggled (same-tab; `storage` does not run in-tab). */
export const SESSION_DEBUG_MODE_CHANGED_EVENT = 'lyw-session-debug-mode-changed';

function notifySessionDebugModeChanged() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(SESSION_DEBUG_MODE_CHANGED_EVENT));
  }
}

export function enableSessionDebugMode() {
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.setItem(SESSION_DEBUG_MODE_KEY, '1');
    notifySessionDebugModeChanged();
  }
}

export function disableSessionDebugMode() {
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.removeItem(SESSION_DEBUG_MODE_KEY);
    notifySessionDebugModeChanged();
  }
}

export function isSessionDebugModeEnabled() {
  if (typeof sessionStorage === 'undefined') return false;
  return sessionStorage.getItem(SESSION_DEBUG_MODE_KEY) === '1';
}
